import {sortArray} from "./DataUtils";
import {FOLDER_TYPE, NODE_LEVEL} from "../domain/HierarchyConstants";
import {CONTENT_OFFSET} from "../domain/ContentOffset";
import {
    buildContentFolders,
    buildRowObject,
    buildServiceTypeHierarchyMap,
    buildServiceTypesHierarchy,
    flattenHierarchy
} from "./ContentHierarchyDataHelper";

export const buildPublishingPlanHierarchy = (publishingPlanData, allPerformerContentWithServiceType) => {

    const publishingPlanRow = [];
    const publishingPlans = publishingPlanData?.contentPublishingPlans.map(item => {

        const publishingPlanOffsetId = item.id + (item.content.id * CONTENT_OFFSET.PUBLISHING_PLAN_ID_OFFSET);
        return {
            id: publishingPlanOffsetId,
            originalId: item.id,
            text: item.content.name,
            level: item.content.level,
            parent: item.content.id,
            type: NODE_LEVEL.CHILD,
            from: item.from,
            to: item.to,
            perpetual: item.perpetual,
        }
    });

    const contentInfos = allPerformerContentWithServiceType.contentInfos.map(item => {
            const parentServiceType = allPerformerContentWithServiceType?.serviceTypes.find(serviceType => serviceType.id === item.serviceType.id);

            const contentInfoOffsetId = item.id + (item.serviceType.id * CONTENT_OFFSET.CONTENT_INFO_ID_OFFSET);
            const contentInfoParentId = item.contentFolderId
                    ? item.contentFolderId + (item.serviceType.id * CONTENT_OFFSET.CONTENT_FOLDER_ID_OFFSET)
                    : item.serviceType.id;

            return {
                id: contentInfoOffsetId,
                originalId: item.id,
                text: item.name,
                externalName: item.nameExternal,
                level: item.level,
                contentType: item.contentType,
                externalUrl: item.externalUrl,
                externalUrlName: item.externalUrlName,
                parent: contentInfoParentId,
                type: NODE_LEVEL.CHILD,
                primaryColor: parentServiceType ? parentServiceType.primaryColor : null,
                serviceTypeKeycode: parentServiceType ? parentServiceType.keycode : null,
                serviceTypeDescription: parentServiceType ? parentServiceType.description : null,
                folderType: FOLDER_TYPE.CONTENT_INFO
            }
        });

    const contentFolders = buildContentFolders(allPerformerContentWithServiceType, contentInfos);
    const serviceTypes = buildServiceTypesHierarchy(allPerformerContentWithServiceType, contentFolders, contentInfos);
    const serviceTypeHierarchyMap = buildServiceTypeHierarchyMap(serviceTypes, contentFolders, contentInfos);

    const flattenedHierarchy = serviceTypeHierarchyMap.reduce((accreditation, serviceType) => {
        const flattenedServiceType = flattenHierarchy(serviceType);
        return [...accreditation, ...flattenedServiceType];
    }, []);

    const additionalProperties = {};
    const serviceTypeRow = serviceTypes.map(serviceType => buildRowObject(flattenedHierarchy, serviceType, additionalProperties));
    const contentFolderRow = contentFolders.map(contentFolder => buildRowObject(flattenedHierarchy, contentFolder, additionalProperties));
    const contentInfoRow = contentInfos.map(contentInfo => {
        const {originalId: contentInfoId, externalName, level, contentType, externalUrlName, externalUrl, serviceTypeKeycode, serviceTypeDescription} = contentInfo;
        return buildRowObject(flattenedHierarchy, contentInfo, {contentInfoId, externalName, level, contentType, externalUrlName, externalUrl, serviceTypeKeycode, serviceTypeDescription});
    });

    const sortedContentInfos = sortArray(contentInfoRow, 'contentNameHierarchy');
    const sortedContentFolders = sortArray(contentFolderRow, 'contentNameHierarchy');

    sortedContentInfos.forEach(contentInfoRow => {
        const plans = publishingPlans.filter(publishingPlan => publishingPlan.parent === contentInfoRow.originalId);

        if (plans.length) {
            plans.forEach(plan => {

                const {contentInfoId, primaryColor, secondaryColor, serviceTypeKeycode, serviceTypeDescription, level} = contentInfoRow;
                const contentPlanId = `${contentInfoRow.id}_${plan.originalId}`;
                publishingPlanRow.push({
                    id: contentPlanId,
                    hierarchy: [...contentInfoRow.hierarchy, contentPlanId],
                    displayName: plan.text,
                    start: plan.from,
                    folderType: FOLDER_TYPE.PUBLISHING_PLANS,
                    end: plan.to,
                    perpetual: plan.perpetual,
                    contentInfoId,
                    primaryColor,
                    secondaryColor,
                    serviceTypeKeycode,
                    serviceTypeDescription,
                    level,
                });
            });
        }

    });

    return {publishingPlanRow, serviceTypeRow, sortedContentInfos, sortedContentFolders};
}
